// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"uq-z","imageAndVideoCount":"vq-z","imageAndVideoContainer":"wq-z","viewAllReviews":"xq-z"};